export default __webpack_public_path__ + "0fe213d.png";